<template>
  <div class="mod-extra-book clearfix">
    <l8-cart
      v-if="cart"
      ref="cart"
      :id="cart.shoppingCartId"
      :value="cart"
      :isJJC="isJJC"
    ></l8-cart>
    <div class="container clearfix">
      <div class="products-top">
        <product-category
          :cart="cart"
          :currentProduct="currentProduct"
          :productBase="productBase"
          @select="onSelectProduct"
          v-if="ifInternational"
        />
      </div>
      <div class="clearfix" v-show="(currentProduct && ifInternational) || !ifInternational">
        <div class="flights-left">
          <flight-follow
            :itinerarys="itinerarys"
            :current="current"
            :currentProduct="currentProduct"
            @select="onSelectPassenger"
          />
        </div>
        <div class="products-right">
          <a-spin :spinning="fetchLoading" >
            <products
              ref="products"
              :itinerarys="itinerarys"
              :segment="itinerarys[current.segmentIndex]"
              :current="current"
              :currentProduct="currentProduct"
              :cart="cart"
              :isSelfAirline="isSelfAirline"
              :ifInternational="ifInternational"
              :productDesList="productDesList"
              :insuranceDesList="insuranceDesList"
              :noProductTipsConfig="noProductTipsConfig"
              :fetchLoading="fetchLoading"
              :productBase="productBase"
              @select="onSelectChange"
              @contactChange="contactValueChange"
            />
          </a-spin>
        </div>
      </div>
      <div class="cards-container clearfix" v-if="cardCouponEnable">
        <card-module
          v-if="!ifInternational && isSelfAirline"
          ref="cardCoupon"
          type="cardCoupon"
          :cardCoupons="cardCoupons"
          :usedCardCoupons="checkedCoupons"
          :cardAgreement="cardAgreementList"
          :productBase="productBase"
          :loading="cardReady === 1"
          :disabled="disableCoupon"
          @visible="fetchEnableCardList"
          @change="updateCardCouponInCart"
        ></card-module>
      </div>
      <div class="foot">

        <div class="agreement">
          <p>
            <AgreementTrack
              :checked="agree"
              :cmsId="agreeListModuleId"
              description='机票下单'
              pageName='flight_book'
              @change="handleIsAgree"
            >
            </AgreementTrack>
            <span class="agreement-text">
              我已阅读并接受
              <template>
                <template v-for="(item, index) in agreeListWithFilter">
                  <router-link :to="item.url" :key="item.url" target="_blank">{{ item.name }}{{ index === (agreeListWithFilter?.length - 1) ? '' : '，'}}</router-link>
                </template>
              </template>
              <template v-if="agreeExtraInfo">{{ agreeExtraInfo }}</template>
            </span>
          </p>
        </div>
        <div class="action">
          <a-button
            class="btn"
            @click="back"
          >上一步</a-button>
          <a-button
            class="btn"
            type="primary"
            @click="next"
            v-if="!nextLoading"
          >提交订单</a-button>
          <a-button
            v-else
            type="dashed"
            class="btn"
          >{{loadingText}}</a-button>
        </div>

        <a-modal v-model="mustReadModalVisible" title="请阅读《国内运输总条件》" >
          <template slot="footer">
            <a-button key="back" @click="handleCancel">
              取消
            </a-button>
            <a-button key="submit" type="primary" :disabled="tenSecondLoading" @click="handleOk">
              确认
              <span v-if="tenSecond > 0" style="margin-left: 10px">{{tenSecond}}秒</span>
            </a-button>
          </template>
          <div class="content" style="max-height:400px; overflow-y: auto" v-if="transportation_cond">
            <h3 class="title" style="margin-bottom: 15px; font-size: 20px; text-align: center;">{{ transportation_cond?.title }}</h3>
            <div v-html="transportation_cond?.content"></div>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { queryProductsList, removeProduct, addProduct, pushInsurance } from '@/apis/extra'
import { submitOrder } from '@/apis/order'
import { queryCardCoupon, addCardCoupon } from '@/apis/coupon'
import queryString from 'query-string'
import flightFollow from './components/flight-follow.vue'
import products from './components/products.vue'
import cardModule from './components/card-module.vue'
import ProductCategory from './components/product-category.vue'
import AgreementTrack from '@/components/agreement-track'
import { message } from 'ant-design-vue'
import _ from 'lodash'
import moment from 'moment'
import storage from '@/assets/js/storage'
import { getNetFareAmount, filterRegion } from '@/assets/js/util'
import { passengerTypeMap } from '@/dicts/common'
import Observer from '@/assets/js/observer'
import { productTypeList, intlProductTypeList, productConfig } from './data/config'
import './index'

const productTypeMap = {
  LUGGAGE: 'luggage',
  MEAL: 'meal',
  INSURANCE: 'insurance',
  SEAT: 'seat',
  // FEESEAT: 'feeSeat',
  ITINERARY: 'itinerary'
}
const productTypeConvertMap = {
  luggage: 'LUGGAGE',
  meal: 'MEAL',
  insurance: 'INSURANCE',
  lugInsurance: 'INSURANCE',
  itinerary: 'ITINERARY',
  seat: 'SEAT'
}
const trackTypeCoverMap = {
  luggage: 'bagged',
  meal: 'meal',
  insurance: 'insurance',
  itinerary: 'itinerary'
}

const productType = Object.keys(productTypeMap)
productType.pop()

const airline = window.__MICRO_ROOT__?.airline

export default {
  data () {
    return {
      cart: null,
      itinerarys: [],
      current: {
        segmentIndex: 0,
        passengerIndex: 0
      },
      currentProduct: '',
      nextLoading: false,
      loadingText: '正在提交...',
      fetchLoading: true,
      agree: false,
      agreeList: [],
      agreeListModuleId: '',
      agreeExtraInfo: '',
      isJJC: Boolean(storage.getItem('isJJC')) || false,
      mustReadModalVisible: false,
      tenSecondLoading: false,
      tenSecond: 5,
      transportation_cond: {},
      selfAgreeMentList: [],
      mutualAgreeMentList: [],
      seatAgreeMentList: [],
      insuranceDesList: [],
      productDesList: [],
      cardAgreementList: [],
      shoppingCart: storage.getItem(`SHOPPINGCART_DATA`),
      payUrl: null,
      ifInternational: false,
      mustReadSwitchConfig: false,
      mustReadDurationConfig: null,
      noProductTipsConfig: [],
      contact: {},
      itineraryProduct: {},
      cardCouponClone: {},
      cardCoupons: [],
      disabledCoupons: [],
      excludeCardCoupons: [],
      checkedCoupons: [],
      cardReady: 0,
      ancillaryCartItems: [],
      track: {
        startPostTime: null,
        endPostTime: null
      },
      cardCouponEnable: false,
      isAgent: [1, 2].includes(window.__MICRO_ROOT__?.user?.get()?.userType),
      productTypeAfterQuery: [],
      loadedTypes: []
    }
  },
  provide () {
    return {
      ifInternational: () => this.ifInternational
    }
  },
  async created () {
    const { isAgent } = this
    const query = queryString.parse(location.search)
    const shoppingCartId = this.shoppingCart?.shoppingCartId
    this.ifInternational = this.shoppingCart?.ifInternational
    await this.getCmsData()

    if (query.from && query.from === 'ehanglian') {
      // 从航联取消回来，提示用户
      this.$confirm({
        title: '请重购增值服务',
        okText: '去购买',
        cancelText: '取消'
      })
    }

    if (shoppingCartId) {
      await this.fetchCart(shoppingCartId)
    } else {
      this.$error({
        title: '温馨提示',
        content: '预订异常，请重新下单',
        onOk: () => {
          this.$router.push({ path: '/flight/search' })
        }
      })
    }
    // NOTE: 国际航班默认选择第一个产品
    if (this.ifInternational) {
      this.onSelectProduct('luggage')
    }
    this.payUrl = !isAgent ? '/pay/v2/pay' : '/pay/v1/pay'
    window.__MICRO_ROOT__?.api?.track?.('reserve_ancillary_view')
  },
  watch: {
    current: {
      handler: function (val) {
        if (val) {
          this.updateBenefit()
        }
      },
      deep: true
    }
  },
  computed: {
    // TODO: 待处理
    isSelfAirline () {
      const { itinerarys, cart, ifInternational } = this
      if (!cart || !itinerarys) {
        return false
      }
      let flag = false
      if (!ifInternational) {
        flag = _.get(itinerarys[0], 'orgDsts[0].airlineCode') === airline
      } else {
        itinerarys.map(itinerary => {
          const airlineCode = itinerary.orgDsts.find(orgDst => orgDst.isMainSegment)?.airlineCode
          if (airlineCode === airline) {
            flag = true
          }
        })
      }
      return flag
    },
    agreeListWithFilter () {
      // type:  all | self | other
      // 航班类型
      const { isSelfAirline, agreeList, ifInternational } = this
      const agreeListWithFilter = agreeList?.filter(item => {
        const currentType = item.type === 'all' ||
      (item.type === 'self' && isSelfAirline) ||
      (item.type === 'other' && !isSelfAirline)
      // 航班地区
        const currentRegion = filterRegion(item, ifInternational)
        return currentType && currentRegion
      }) ?? []
      return agreeListWithFilter
    },
    disableCoupon () {
      const passengers = this.itinerarys?.[0]?.passengers || []
      return passengers.length > 1
    },
    // 辅营产品配置，组装 cms 配置和本地配置文件的结果
    productBase () {
      const { productDesList, ifInternational } = this
      const productBase = {}
      const typeList = ifInternational ? intlProductTypeList : productTypeList
      typeList.forEach(type => {
        let productBaseByCms = productDesList.find(item => { return item.key === type })
        productBaseByCms = _.omitBy(productBaseByCms, (v) => _.isUndefined(v) || _.isNull(v) || v === '')
        productBase[type] = productBaseByCms ? { ...productConfig[type], ...productBaseByCms } : productConfig[type]
      })
      return productBase
    }
  },
  methods: {
    async getCmsData () {
      const { ifInternational } = this
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.transportation_cond = _.get(pageCmsData, 'extra-condition') ?? {}
      this.agreeList = _.get(pageCmsData, 'extra-agree.list') ?? []
      this.agreeListModuleId = _.get(pageCmsData, 'extra-agree._moduleId') ?? ''
      this.agreeExtraInfo = _.get(pageCmsData, 'extra-agree.info') ?? ''
      this.insuranceDesList = _.get(pageCmsData, !ifInternational ? 'extra-insurance-desc.infomation' : 'extra-insurance-desc-int.infomation') ?? []
      this.productDesList = _.get(pageCmsData, !ifInternational ? 'extra-product-desc.infomation' : 'extra-product-desc-int.infomation') ?? []
      this.mustReadSwitchConfig = _.get(pageCmsData, 'config.mustReadSwitchConfig') ?? false
      this.mustReadDurationConfig = _.get(pageCmsData, 'config.mustReadDurationConfig') ?? this.tenSecond
      this.cardCouponEnable = _.get(pageCmsData, 'config.cardCouponEnable') ?? false
      this.noProductTipsConfig = _.get(pageCmsData, 'noProductTips.list') ?? []
      this.cardAgreementList = _.get(pageCmsData, 'card-agree.list') ?? []
    },
    // 请求购物车
    async fetchCart (shoppingCartId) {
      try {
        const { ifInternational, isAgent } = this
        const result = await removeProduct({ shoppingCartId, ifInternational })
        this.cart = result
        this.$nextTick(async () => {
          const itinerarys = []
          result.offers.forEach(seg => {
            if (!ifInternational) {
              const segment = seg.detail.itinerarys[0]
              const passengers = seg.detail.passengers
              // segment.passengers = passengers
              this.$set(segment, 'passengers', _.cloneDeep(passengers))
              itinerarys.push(segment)
            } else {
              seg.detail.itinerarys[0].orgDsts.forEach(orgDst => {
                const itinerary = seg.detail.itinerarys[0]
                const segment = {
                  ...itinerary,
                  orgDsts: [orgDst]
                }
                const passengers = seg.detail.passengers
                // 选座判断需要
                passengers.forEach(passenger => {
                  if (passenger.passengerType === 'INF' && passenger.accompanyPassenger) {
                    const intPassengerAccompanyInfo = passenger.accompanyPassenger
                    const accompanyPassengerIndex = passengers.findIndex(item => item.certificateType === intPassengerAccompanyInfo.certificateType && item.certificateNo === intPassengerAccompanyInfo.certificateNo)
                    if (accompanyPassengerIndex > -1) {
                      passengers[accompanyPassengerIndex].hasAccompany = true
                    }
                  }
                })
                // segment.passengers = _.cloneDeep(passengers)
                this.$set(segment, 'passengers', _.cloneDeep(passengers))
                itinerarys.push(segment)
              })
            }
          })
          this.itinerarys = itinerarys
          this.updateBenefit()
          // this.fetchBenefit()

          // TODO: 国际票第一期不上随票辅营
          // if (ifInternational) {
          //   this.fetchLoading = false
          //   return false
          // }

          const count = itinerarys.length

          // if (ifInternational) {
          //   const index = productType.findIndex(type => type === 'SEAT')
          //   productType.splice(index, 1, 'FEESEAT')
          // }
          if (!ifInternational) {
            for (let i = 0; i < count; i++) {
              for (const type of productType) {
                await this.fetchProduct(i, type)
              }

              // 行程单只请求一次
              if (i === count - 1 && !isAgent) {
                await this.fetchProduct(i, 'ITINERARY')
              }
            }

            // 多行程时，前面行程拷贝最后一个行程的行程单产品
            if (count > 1) {
              const iteneraryProducts = this.itinerarys[count - 1].itinerary

              for (let i = 0; i < count - 1; i++) {
                this.$set(this.itinerarys[i], 'itinerary', iteneraryProducts)
              }
            }
          }

          this.fetchLoading = false
        })
      } catch (err) {
        this.fetchLoading = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },
    // 请求航班对应类型辅营产品
    async fetchProduct (index, productType) {
      const { itinerarys = [], productBase, ifInternational, cart } = this
      const seg = itinerarys[index].orgDsts[0]
      const params = {
        businessParams: {
          airlineCode: seg.airlineCode,
          arrCode: seg.arrivalCode,
          bookingType: 'FOLLOW',
          depCode: seg.departureCode,
          flightDay: seg.departureDate,
          flightNo: seg.flightNo,
          flightTime: seg.departureTime,
          productCode: seg.productCode,
          cabinCode: seg.cabinCode,
          arrTime: seg.arrivalTime,
          ticketNo: ''
        },
        productType: productType,
        publishType: 'SELF_BIZ',
        serviceTime: seg.departureDate,
        shoppingCartId: cart.shoppingCartId
      }
      // NOTE: JD 有多个舱位的时候如往返程，需要对所有舱位判断返回行程单价格
      if (airline === 'JD' && productType === 'ITINERARY') {
        params.businessParams.cabinCode = itinerarys.map(itinerary => itinerary.orgDsts?.[0]?.cabinCode)?.join(',')
      }
      // CMS 控制是否查询指定类型的产品
      const productSwitch = productBase?.[productTypeMap[productType]]?.followSwitchStatus
      if (_.isBoolean(productSwitch) && !productSwitch) {
        return false
      }

      if (productType === 'SEAT') {
        const { segmentIndex, passengerIndex } = this.current
        // const passenger = this.itinerarys[segmentIndex].passengers[passengerIndex]
        // if (passenger.passengerType === 'ADT' && passenger.hasAccompany) {
        //   return false
        // }
        params.businessParams.passengerType = itinerarys[segmentIndex]?.passengers?.[passengerIndex]?.passengerType
        params.businessParams.passengerName = itinerarys[segmentIndex]?.passengers?.[passengerIndex]?.fullName
      }
      try {
        const result = await queryProductsList(params)

        let productPrices = Array.isArray(result) && result.length > 0 ? _.get(result[0], 'detail.productPrices') : []
        const arrSelect = []
        // 处理特殊产品-预选座
        if (productType === 'SEAT' && result[0]?.detail) {
          if (ifInternational) {
            const service = productPrices[0]?.services[0]?.shoppingResDTO
            const { dataLists, offers } = service
            const { offerItems } = offers?.[0] || {}
            const { seat: seats } = dataLists?.flightSegmentList[0]?.seatMapList?.[0] || {}
            const offerItemMap = {}

            offerItems?.forEach((offer) => {
              const { fareDetails, offerItemID, serviceDTOs } = offer
              // 获取价格
              let price = null
              let currency = null
              fareDetails?.[0]?.fares?.forEach((fare) => {
                if (fare?.code === 'NetFare') {
                  price = fare?.amount
                  currency = fare?.currency
                }
              })
              // 获取座位信息
              const offerItemRow = serviceDTOs?.[0]?.seat?.row
              const offerItemCol = serviceDTOs?.[0]?.seat?.column
              const currentSeat = offerItemRow + offerItemCol
              const isPaySeat = serviceDTOs?.[0]?.seat?.status === 'U'
              if (currentSeat) {
                offerItemMap[currentSeat] = {
                  offerItemId: offerItemID,
                  price,
                  currency,
                  isPaySeat
                }
              }
            })
            // 遍历初始座位数组，填充至聚合数组中
            seats?.forEach((seat) => {
              const { row: seatRow, col: seatCol } = seat
              const currentSeat = seatRow + seatCol
              seat.offerItemId = offerItemMap?.[currentSeat]?.offerItemId // 座位对应的offerItemId
              seat.price = offerItemMap?.[currentSeat]?.price // 座位对应的价格
              seat.currency = offerItemMap?.[currentSeat]?.currency // 座位对应的货币
              seat.isPaySeat = offerItemMap?.[currentSeat]?.isPaySeat // 座位是否付费
            })
          }
          const seatMap = !ifInternational ? productPrices[0]?.seatMap : productPrices[0]?.services[0]?.shoppingResDTO?.dataLists?.flightSegmentList[0]?.seatMapList?.[0]
          const extraData = ifInternational ? productPrices[0]?.services[0]?.shoppingResDTO : {}
          productPrices = [
            {
              services: [
                {
                  productCode: 'SEAT',
                  productName: '预选座值机',
                  serviceType: 'SEAT',
                  mustSelect: false,
                  seatMap,
                  extraData
                }
              ],
              type: 'SEAT'
            }
          ]
          result[0].detail.productPrices = productPrices
        }

        productPrices.forEach(product => {
          // 处理必选产品
          const mustSelect = product.services[0].mustSelect
          if (mustSelect) {
            const value = product.services[0]
            arrSelect.push(value)
            const cartValue = {
              offerItemType: value.serviceType,
              detail: {
                offerItemId: value.offerItemId,
                productCode: value.productCode,
                productName: value.productName,
                price: getNetFareAmount(value.fareDetails),
                count: itinerarys[index].passengers.length
              }
            }
            this.$refs.cart.add(cartValue, index)
          }
          // 临时处理，前端控制仅 JD 餐食支持复选
          if (['JD', '8L'].includes(airline) && product.type === 'MEAL') {
            this.$set(product.services[0], 'productNum', 0)
            this.$set(product.services[0], 'isComplex', true)
          }
        })
        if (arrSelect.length) {
          const passengers = itinerarys[index].passengers || []
          passengers.forEach(psg => {
            psg['select'] = { [productTypeMap[productType]]: arrSelect }
          })
          this.$set(this.itinerarys[index], 'passengers', passengers)
        }

        if (ifInternational && productPrices.length > 0) {
          this.productTypeAfterQuery.push(productTypeMap[productType])
        }

        this.$set(this.itinerarys[index], productTypeMap[productType], result)
      } catch (e) {
        this.$message.error(e.message || '网络异常，请稍后再试！')
      }
    },
    // 左侧行程乘客选择
    async onSelectPassenger (current) {
      this.current = current
      // this.updateBenefit()
      if (this.currentProduct === 'seat') {
        this.fetchLoading = true
        await this.fetchProduct(current.segmentIndex, 'SEAT')
        this.fetchLoading = false
      }
    },
    async onSelectProduct (productType) {
      const { itinerarys, current } = this
      if (this.currentProduct === productType) {
        this.currentProduct = ''
        return false
      } else {
        this.currentProduct = productType
      }

      if (this.loadedTypes.includes(productType)) {
        return false
      }
      this.fetchLoading = true
      const count = itinerarys.length
      const productTypeConvert = productTypeConvertMap[productType]
      // 仅首次点击获取产品
      for (let i = 0; i < count; i++) {
        switch (productTypeConvert) {
          case 'SEAT':
            // this.current = {}
            // 选座默认获取当前行程
            if (i === current.segmentIndex) {
              await this.fetchProduct(i, productTypeConvert)
            }
            break
          default:
            await this.fetchProduct(i, productTypeConvert)
            break
        }
      }
      if (productType !== 'seat') {
        this.loadedTypes.push(productType)
      }
      // 多行程时，前面行程拷贝最后一个行程的行程单产品
      // if (count > 1) {
      //   const iteneraryProducts = this.itinerarys[count - 1].itinerary
      //   for (let i = 0; i < count - 1; i++) {
      //     this.$set(this.itinerarys[i], 'itinerary', iteneraryProducts)
      //   }
      // }

      this.fetchLoading = false
      const index = itinerarys.findIndex(itinerary => itinerary[productType]?.length > 0)
      this.$set(this.current, 'segmentIndex', index >= 0 ? index : 0)
    },
    // 辅营产品选择
    onSelectChange (type, value) {
      // const itinerarys = this.itinerarys
      // const passengers = itinerarys[segmentIndex].passengers || []
      // const select = passengers[passengerIndex].select || {}
      // select[type] = value
      // passengers.splice(passengerIndex, 1, {
      //   ...passengers[passengerIndex],
      //   select
      // })
      // this.itinerarys.splice(segmentIndex, 1, {
      //   ...itinerarys[segmentIndex],
      //   passengers
      // })
      this.updateSelectItem(type, value)
      this.updateProductInCart()
      // NOTE: 产品变化，需要重新查询卡券
      this.$set(this.$refs.cardCoupon, 'show', false)

      // TODO: 不再通过前端更新购物车
      // if (add) {
      //   // 添加购物车
      //   this.$refs.cart.add(cartValue, segmentIndex)
      // } else {
      //   this.$refs.cart.remove(cartValue, segmentIndex)
      // }
      const trackKey = `reserve_ancillary_${trackTypeCoverMap[type]}`
      window.__MICRO_ROOT__?.api?.track?.(trackKey)
    },
    // 行程单数据变化
    contactValueChange (cartValue, contact, value) {
      const { itineraryProduct } = this
      let isPrepared = true
      if (contact && contact.invoice === 'Y') {
        for (const key in contact) {
          if (contact.hasOwnProperty(key) && contact[key] === '') {
            isPrepared = false
            break
          }
        }
      } else {
        isPrepared = false
      }
      if (isPrepared) {
        this.contact = contact
        this.itineraryProduct = cartValue
        this.updateSelectItem('itinerary', value)
        this.updateProductInCart()
      }
      if (!isPrepared && itineraryProduct) {
        this.contact = {}
        this.itineraryProduct = null
        this.updateSelectItem('itinerary', {})
        this.updateProductInCart()
      }
    },
    updateSelectItem (type, value) {
      const { segmentIndex, passengerIndex } = this.current
      const itinerarys = this.itinerarys
      const passengers = itinerarys[segmentIndex].passengers || []
      const select = passengers[passengerIndex].select || {}
      select[type] = value
      passengers.splice(passengerIndex, 1, {
        ...passengers[passengerIndex],
        select
      })
      this.itinerarys.splice(segmentIndex, 1, {
        ...itinerarys[segmentIndex],
        passengers
      })
    },
    getAncillaryCartItems () {
      const { itinerarys, contact, itineraryProduct } = this
      const mapItems = {}

      itinerarys.forEach(seg => {
        seg.passengers.forEach((psg, index) => {
          const selects = Object.keys(psg.select || {})?.filter(key => key !== 'itinerary')
          selects.forEach(key => {
            const arr = psg.select[key]
            Array.isArray(arr) && arr.forEach(product => {
              const couponsValue = product.coupons
              if (mapItems[product.offerItemId]) {
                // 有这个产品
                mapItems[product.offerItemId].passengers.push({
                  offerItemId: product.offerItemId,
                  passengerId: psg.passengerId,
                  certificateType: psg.certificateType,
                  certificateNo: psg.certificateNo,
                  passengerName: psg.fullName,
                  passengerNum: 1,
                  productNum: product.productNum
                })
                const len = mapItems[product.offerItemId].passengers.length
                if (couponsValue && !_.isEmpty(couponsValue)) {
                  mapItems[product.offerItemId].passengers[len - 1].couponType = couponsValue.couponType
                  mapItems[product.offerItemId].passengers[len - 1].couponNumber = couponsValue.couponNumber
                }
              } else {
                //  没有这个产品
                mapItems[product.offerItemId] = {
                  offerItemId: product.offerItemId,
                  serviceId: seg.orgDsts[0].serviceId,
                  offerItemType: productTypeConvertMap[key],
                  depCode: seg.orgDsts[0].departureCode,
                  arrCode: seg.orgDsts[0].arrivalCode,
                  productName: product.productName,
                  productCode: product.productCode,
                  passengers: [{
                    offerItemId: product.offerItemId,
                    passengerId: psg.passengerId,
                    certificateType: psg.certificateType,
                    certificateNo: psg.certificateNo,
                    passengerName: psg.fullName,
                    passengerNum: 1,
                    productNum: product.productNum
                  }]
                }
                if (couponsValue && !_.isEmpty(couponsValue)) {
                  mapItems[product.offerItemId].passengers[0].couponType = couponsValue.couponType
                  mapItems[product.offerItemId].passengers[0].couponNumber = couponsValue.couponNumber
                }
              }
            })
          })
        })
      })

      const ancillaryCartItems = []
      for (let key in mapItems) {
        ancillaryCartItems.push(mapItems[key])
      }

      if (contact && contact.invoice === 'Y') {
        const seg = itinerarys[itinerarys.length - 1]
        const product = !_.isEmpty(itineraryProduct) ? itineraryProduct.detail : { offerItemId: '' }
        let arrPassengers = []
        seg.passengers.forEach(psg => {
          arrPassengers.push(
            {
              offerItemId: product.offerItemId,
              passengerId: psg.passengerId,
              certificateType: psg.certificateType,
              certificateNo: psg.certificateNo,
              passengerName: psg.fullName,
              passengerNum: 1
            })
        })
        ancillaryCartItems.push({
          offerItemId: product.offerItemId,
          serviceId: seg.orgDsts[0].serviceId,
          offerItemType: 'ITINERARY',
          depCode: seg.orgDsts[0].departureCode,
          arrCode: seg.orgDsts[0].arrivalCode,
          passengers: arrPassengers,
          itinerary: contact,
          productName: product.productName,
          productCode: product.productCode
        })
      }
      return ancillaryCartItems
    },
    // NOTE: 通过防抖，防止因为切换辅营产品同时触发取消和新增的请求的响应时间不同导致的bug
    updateProductInCart: _.debounce(async function () {
      this.fetchLoading = true

      const { ifInternational, cart } = this

      const extraParams = {
        shoppingCartId: cart.shoppingCartId,
        ancillaryCartItems: this.getAncillaryCartItems(),
        ifInternational
      }

      try {
        const result = await addProduct(extraParams)
        this.fetchLoading = false
        if (result) {
          this.cart = result
          // NOTE: 更新辅营产品购物车，需要重置卡券
          if (this.checkedCoupons?.length > 0) {
            this.checkedCoupons = []
            this.updateCardCouponInCart()
          }
        } else {
          message.error(result.data)
        }
      } catch (e) {
        this.fetchLoading = false
        message.error(e.message)
      }
    }, 500),
    back () {
      window.history.go(-1)
    },
    next () {
      window.__MICRO_ROOT__?.api?.track?.('reserve_ancillary_book')
      const { contact, agree, ifInternational } = this
      if (!agree) {
        this.$message.error('请阅读并接受协议！')
        return
      }

      this.nextLoading = true
      this.loadingText = '正在提交...'

      // 添加行程单
      if (contact && contact.invoice === 'Y') {
        let bShow = false

        for (const key in contact) {
          if (contact.hasOwnProperty(key) && contact[key] === '') {
            bShow = true
            break
          }
        }
        if (bShow) {
          this.nextLoading = false
          message.error('请完善行程单信息')
          return
        }
      }
      const ancillaryCartItems = this.getAncillaryCartItems()
      if (!ancillaryCartItems.length) {
        this.skip()
        return
      }
      const observer = new Observer()

      // NOTE: JD - 复合餐食提示，超过3份需要提示用户
      if (['JD', '8L'].includes(airline)) {
        let mealSum = 0
        let hasInsurance = false
        ancillaryCartItems?.forEach(ancillaryCartItem => {
          const { passengers = [], offerItemType } = ancillaryCartItem
          if (offerItemType === 'MEAL') {
            passengers?.forEach(passenger => {
              mealSum += passenger.productNum
            })
          }
          if (offerItemType === 'INSURANCE') {
            hasInsurance = true
          }
        })

        if (mealSum >= 3) {
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                content: `您好，您当前下单的餐食数量共计${mealSum}份，请确认您预定的餐食数量及支付金额。如为操作失误，请修改后下单。谢谢！`,
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                  resolve()
                },
                onCancel: () => {
                  this.nextLoading = false
                  reject(new Error('cancel'))
                }
              })
            })
          })
        }

        if (hasInsurance) {
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                content (h) {
                  return (
                    <div>
                      1、订单支付暂时只支持支付宝支付；<br/>
                      2、根据相关规定需要您前往航联保险确认信息，点击“确定”生单成功后将前往航联保险信息确认页
                    </div>
                  )
                },
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                  resolve()
                },
                onCancel: () => {
                  this.nextLoading = false
                  reject(new Error('cancel'))
                }
              })
            })
          })
        }
      }

      observer.complete = () => {
        const extraParams = {
          shoppingCartId: this.cart?.shoppingCartId,
          ancillaryCartItems: ancillaryCartItems,
          ifInternational
        }
        this.addExtras(extraParams)
      }

      observer.start()
    },
    async addExtras (extraParams) {
      const { cart, payUrl, ifInternational } = this
      try {
        const res = await addProduct(extraParams)
        if (res) {
          this.nextLoading = true
          this.loadingText = '正在跳转...'

          // 判断是否有保险，有保险跳到航联页面
          const idx = _.findIndex(extraParams.ancillaryCartItems, item => {
            return item.offerItemType === 'INSURANCE'
          })

          this.$message.success('提交成功', async () => {
            if (idx > -1) {
              try {
                // 国际票辅营页跳生单页需要携带ifInternational参数
                const extraParams = ifInternational ? '&ifInternational=true' : ''
                const params = {
                  shoppingCartId: cart.shoppingCartId,
                  confirmUrl: encodeURIComponent(`${location.origin}/micro/main${payUrl}?from=ehanglian${extraParams}`),
                  cancelUrl: encodeURIComponent(`${location.origin}/micro/main/extrafollow/book?from=ehanglian${extraParams}`)
                }
                const { url } = await pushInsurance(params)
                // 跳转第三方地址
                location.href = url
              } catch (error) {
                message.error(error.message)
                this.nextLoading = false
              }
            } else {
              this.handleToPayPage()
            }
          })
        } else {
          this.nextLoading = false
          message.error(res.data)
        }
      } catch (e) {
        this.nextLoading = false
        message.error(e.message)
      }
    },
    skip () {
      this.nextLoading = true
      this.loadingText = '正在提交...'
      this.handleToPayPage()
    },
    // 请求航班权益
    // fetchBenefit () {
    //   const products = _.map(this.itinerarys, (seg) => {
    //     return {
    //       'arrCode': seg.orgDsts[0].arrivalCode,
    //       'cabinCode': seg.orgDsts[0].cabinCode,
    //       'refCabinCode': seg.orgDsts[0].reCabinCode,
    //       'depCode': seg.orgDsts[0].departureCode,
    //       'flightDate': this.moment(seg.orgDsts[0].departureTime).format('YYYY-MM-DD'),
    //       'flightNo': seg.orgDsts[0].flightNo,
    //       'productCode': seg.orgDsts[0].productCode
    //     }
    //   })

    //   const params = {
    //     'airlineCode': window.__MICRO_ROOT__?.airline,
    //     'products': products
    //   }

    //   request({
    //     method: 'POST',
    //     url: '/api/flight/queryBenefit',
    //     data: params
    //   }).then((res) => {
    //     this.updateBenefit(res.benefits)
    //   }).catch((error) => {
    //     this.$message.error(error.message || '权益查询失败，请稍候重试。')
    //   })
    // },
    // 设置航班权益
    updateBenefit () {
      const { segmentIndex, passengerIndex } = this.current
      const seg = this.itinerarys[segmentIndex]
      const freeBef = {
        luggage: '0',
        meal: '无'
      }
      // 赋值权益
      _.each(seg.orgDsts, (item) => {
        const _freeBef = _.cloneDeep(freeBef)
        _.get(item, 'benefit.benefits[0].benefitDetails') && item.benefit.benefits[0].benefitDetails.forEach(bef => {
          const mealCodeList = ['MEAL', 'FOOD_IN_THE_AIR']
          if (mealCodeList.indexOf(bef.code) >= 0) {
            _freeBef.meal = bef.name
          }
        })
        _.get(item, 'benefit.benefits[0].languageBenefitDetails') && item.benefit.benefits[0].languageBenefitDetails.forEach(bef => {
          if (bef.passengerType === passengerTypeMap[seg.passengers[passengerIndex].passengerType]) {
            _freeBef.luggage = bef.checkinBenefit?.data
          }
        })
        this.$set(seg, 'benefits', _freeBef)
      })
    },
    async handleToPayPage () {
      const { payUrl, shoppingCart, ifInternational } = this
      this.track.startPostTime = moment(new Date()).valueOf()
      try {
        let submitResult = await submitOrder({
          shoppingCartId: shoppingCart.shoppingCartId,
          ifInternational
        })
        this.track.endPostTime = moment(new Date()).valueOf()

        // TODO: 注意测试覆盖
        if (submitResult.code === '100010001' && submitResult.extraInfo && submitResult.extraInfo.data) {
          submitResult = {
            success: true,
            data: submitResult.extraInfo.data
          }
        } else {
          submitResult = {
            success: true,
            data: submitResult
          }
        }

        // 清理下单流程使用到的Storage
        storage.removeItem(`SHOPPINGCART_DATA`)
        storage.removeItem(`isJJC`)

        if (submitResult.success) {
          storage.setItem(`SUBMIT_RESULT`, submitResult, 0.5 * 3600000)
        }

        this.handleUniTrack()

        const query = {}
        if (ifInternational) {
          query.ifInternational = ifInternational
        }

        this.$router.push({
          path: payUrl,
          query
        })
      } catch (error) {
        const submitResult = {
          success: false,
          message: error.message
        }
        this.track.endPostTime = moment(new Date()).valueOf()
        this.handleUniTrack(error)

        const query = {}
        if (ifInternational) {
          query.ifInternational = ifInternational
        }

        // 清理下单流程使用到的Storage
        storage.removeItem(`SHOPPINGCART_DATA`)
        storage.removeItem(`isJJC`)
        storage.setItem(`SUBMIT_RESULT`, submitResult, 0.5 * 3600000)
        this.$router.push({
          path: payUrl,
          query
        })
      }
    },
    handleIsAgree () {
      const { mustReadSwitchConfig, ifInternational } = this
      if (mustReadSwitchConfig && !ifInternational) {
        this.showMustReadModal()
      } else {
        this.agree = !this.agree
      }
    },
    showMustReadModal () {
      if (this.agree === false) {
        this.tenSecond = this.mustReadDurationConfig
        this.mustReadModalVisible = true
        this.tenSecondLoading = true
        this.clearIntervalFunc()
        this.setIntervalFunc = setInterval(() => {
          if (this.tenSecond > 0) {
            if (this.tenSecond === 1) {
              this.$nextTick(() => {
                this.tenSecondLoading = false
              })
            }

            this.tenSecond--
          } else {
            this.tenSecondLoading = false
            clearInterval(this.setIntervalFunc)
          }
        }, 1000)
      } else {
        this.agree = false
      }
    },
    handleOk () {
      this.mustReadModalVisible = false
      this.agree = true
    },
    handleCancel () {
      this.mustReadModalVisible = false
      this.agree = false
    },
    clearIntervalFunc () {
      clearInterval(this.setIntervalFunc)
    },
    /**
     * 卡券部分
     */
    fetchEnableCardList (isCheck) {
      isCheck && this.queryCardCoupon()
    },
    // 获取可使用卡券列表
    async queryCardCoupon () {
      this.loading = true
      const { shoppingCartId } = this.cart
      const params = {
        shoppingCartId
      }
      this.cardReady = 1
      queryCardCoupon(params).then((result = {}) => {
        this.loading = false
        this.cardReady = 2
        this.cardCouponClone = _.cloneDeep(result.usableCoupon)
        this.cardCoupons = result.usableCoupon?.coupons
        // 不可使用券需展示并置灰
        this.excludeCardCoupons = []
        this.disabledCoupons = []
        result.usableCoupon?.disabledCoupons?.forEach(item => {
          this.disabledCoupons.push({ ...item, disabled: true })
        })
        this.cardCoupons = this.cardCoupons?.concat(this.disabledCoupons)
        // JD 过滤行李畅享卡券
        if (airline === 'JD') {
          this.cardCoupons = this.cardCoupons.filter(item => item.couponConfigProductCode !== 'FXL1')
        }
      }).catch(err => {
        this.loading = false
        this.cardReady = 0
        this.$refs.cardCoupon.show = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    // 使用（取消）卡券
    async updateCardCouponInCart (selectedCoupon = {}) {
      const { cardCouponClone, disabledCoupons = [], checkedCoupons, cart } = this
      const { shoppingCartId } = this.cart
      const { couponCacheId, coupons: cardCouponsClone } = cardCouponClone
      const cardCouponsOrigin = _.cloneDeep(cart.cardCoupons?.coupons)
      const idx = checkedCoupons.findIndex(item => item === selectedCoupon.couponCode)
      if (idx > -1) {
        this.checkedCoupons.splice(idx, 1)
      } else {
        selectedCoupon.couponCode && this.checkedCoupons.push(selectedCoupon.couponCode)
      }
      const coupons = this.checkedCoupons || []
      const params = {
        shoppingCartId,
        couponCacheId,
        coupons
      }
      this.cardReady = 1
      addCardCoupon(params).then(result => {
        this.cart = result
        const { cardCoupons, excludeCardCoupon } = result
        const { coupons: excludeCardCoupons } = excludeCardCoupon
        // 基于结果返回的 excludeCardCoupons 和 cardCoupons 更新卡券列表
        if (excludeCardCoupons?.length > 0 || cardCoupons?.length > 0) {
          const newCoupons = []
          for (let index = 0; index < cardCouponsClone.length; index++) {
            const coupon = cardCouponsClone[index]
            if (cardCoupons.find(cardCoupon => { return coupon.couponCode === cardCoupon.couponCode }) ||
            excludeCardCoupons.find(excludeCardCoupon => { return coupon.couponCode !== excludeCardCoupon.code && excludeCardCoupon.available })) {
              newCoupons.push(coupon)
            }
          }
          // 不可使用券需展示并置灰
          this.excludeCardCoupons = []
          excludeCardCoupons?.forEach(excludeCardCoupon => {
            const item = cardCouponsClone.find(coupon => { return coupon.couponCode === excludeCardCoupon.code })
            this.excludeCardCoupons.push({ ...item, disabled: true })
          })
          this.cardCoupons = newCoupons.concat(this.excludeCardCoupons).concat(disabledCoupons)
        } else {
          // 卡券重置
          this.cardCoupons = cardCouponClone?.coupons?.concat(disabledCoupons)
        }
        // JD 过滤行李畅享卡券
        if (airline === 'JD') {
          this.cardCoupons = this.cardCoupons.filter(item => item.couponConfigProductCode !== 'FXL1')
        }

        this.$message.success(`${this.isAddOrRemove(cardCouponsOrigin, cardCoupons)}优惠券成功`)
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后再试！')
        this.checkedCoupons = this.checkedCoupons.filter(item => { return item !== selectedCoupon.couponCode })
      }).finally(() => {
        this.cardReady = 2
      })
    },
    // 判断卡券是否添加（取消）
    isAddOrRemove (origin = [], target = []) {
      return origin.length < target.length ? '添加' : '取消'
    },
    handleUniTrack (error) {
      try {
        const { itinerarys = [], track } = this
        const { startPostTime, endPostTime } = track
        const postTime = ((endPostTime - startPostTime) / 1000).toFixed(2)
        if (postTime < 0) {
          return
        }
        let productAttr = []
        itinerarys.forEach(itinerary => {
          itinerary.passengers?.forEach(passenger => {
            const { select } = passenger
            if (select) {
              productAttr = productAttr.concat(Object.keys(select))
            }
          })
        })
        productAttr = _.uniq(productAttr)
        productAttr = productAttr.map(item => { return productConfig[item]?.trackName }).join('、')
        const trackParams = {
          flight_org_code: itinerarys[0]?.orgDsts?.[0].departureCode,
          flight_dst_code: itinerarys[0]?.orgDsts?.[0].arrivalCode,
          flight_ticket_business_info: productAttr,
          order_inf_time: postTime,
          order_inf_time_decimal: postTime
        }
        if (error) {
          trackParams.inf_error_info = error.message
        }
        window.__MICRO_ROOT__?.api?.track?.('UNI_PlaceOrder', trackParams)
      } catch (error) {
        console.log('error >>>> ', error.message)
      }
    }
  },
  beforeDestroy () {
    this.clearIntervalFunc()
  },

  components: {
    flightFollow,
    products,
    cardModule,
    ProductCategory,
    AgreementTrack
  }
}
</script>
<style lang="less">
@import "./css/index.less";
</style>
